<template>
  <section>
    <el-form :model="formObj" :rules="formRules" ref="formObj" label-width="120px">
      <el-form-item label="项目" prop="proId">
        <el-select v-model="formObj.proId" placeholder="请选择项目">
          <el-option v-for="(item,index) in GLOBAL.proList" :key="item.id" :value="item.id"
                     :label="item.proName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="examName">
        <el-input v-model="formObj.examName" placeholder="请输入标题" maxlength="20"  show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="时间" prop="time">
        <el-date-picker
          v-model="formObj.time"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-radio-group v-model="method" @change="openRandomView">
<!--          <el-radio-button label="自定义"></el-radio-button>-->
          <el-radio-button label="点击->随机生成试卷"></el-radio-button>
        </el-radio-group>
      </el-form-item>

<!--      <el-form-item v-if="option==0 && method =='自定义'" label="上传试题" prop="dataPath">-->
<!--        <el-upload-->
<!--          class="upload-demo"-->
<!--          :action="this.GLOBAL.businessServerPath+'/examupload'"-->
<!--          :headers="this.GLOBAL.fileHeader"-->
<!--          name="file"-->
<!--          :file-list="fileList"-->
<!--          :limit="1"-->
<!--          :on-exceed="handleExceed"-->
<!--          :on-remove="removeConUpload"-->
<!--          :on-success="successConUpload">-->
<!--          <el-button size="small" type="primary">点击上传</el-button>-->
<!--          <div slot="tip" class="el-upload__tip"></div>-->
<!--        </el-upload>-->
<!--      </el-form-item>-->
    </el-form>
    <div class="dialog-footer" v-if="!randomVisible && option == 1">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
    </div>
    <!-- 表单视图 -->
    <el-dialog title="随机生成试卷" :visible.sync="randomVisible" :close-on-click-modal="false" :modal="false" width="40%" @close="rCancel">
      <el-form :model="rForm" ref="rForm" label-width="120px">
        <el-form-item label="单选题">
          <el-input-number v-model="rForm.singleSelected" controls-position="right" @change="handleChange" :min="0"
                           :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="多选题">
          <el-input-number v-model="rForm.doubleSelected" controls-position="right" @change="handleChange" :min="0"
                           :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="判断题">
          <el-input-number v-model="rForm.checkSelected" controls-position="right" @change="handleChange" :min="0"
                           :max="100"></el-input-number>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click.native="rCancel">取消</el-button>
        <el-button type="primary" @click.native="rSubmit(option)">确定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import {examCreate, examUpdate, examNO, proSearch,randomExam} from '../../api/api'

  export default {
    name: "ExamForm",
    props: {
      option: 0,
      formData: {},
      type: 0,
    },
    data() {
      return {
        formObj: {proId: null, examBeginTime: null, examEndTime: null, examName: null, id: null},
        formRules: {
          proId: [
            {required: true, message: '请选择项目', trigger: 'change'}
          ],
          time: [
            {required: true, message: '请选择考试时间', trigger: 'change'}
          ],
          examName: [
            {required: true, message: '请输入考试名称', trigger: 'blur'}
          ],
        },
        time: null,
        fileList: [],
        dataList: [],//试题集合
        dataNo: [],//题号集合
        no: null,//题号
        tempList: [],//重构试题集合
        proList: [],
        method: '自定义',
        randomVisible: false,
        rForm: {singleSelected:1,doubleSelected:1,checkSelected:1},
        num1: 0,
        num2: 0,
        num3: 0,
      }
    },
    methods: {
      rSubmit: function (option) {
        //随机取得试题
        if((this.rForm.singleSelected==null && this.rForm.doubleSelected == null && this.rForm.checkSelected == null)
          || (this.rForm.singleSelected==0 && this.rForm.doubleSelected == 0 && this.rForm.checkSelected == 0))
        {
          this.rForm.allSelected =50;
        }
        randomExam(this.rForm, this.GLOBAL.header).then(result => {
          if (result.success) {
              this.dataList = result.data;
              if (this.dataList != null) {
                  let allFen = 0;
                  for (let i = 0; i < this.dataList.length; i++) {
                    this.dataNo[i] = parseInt(this.dataList[i].quNo);
                    allFen = allFen + parseFloat(this.dataList[i].quValue);
                  }
                  this.formObj.examAllFen = allFen;//计算总分
                  this.formObj.examQuestion = this.dataNo.join(',');
                  this.doSubmit(option);
              }else {
                this.$message({
                  message: "加载试题失败请关闭重试",
                  type: 'error'
                });
              }

          }
        });

      },
      doSubmit: function (option) {
        let rangTime = this.formObj.time + "";
        let beginTime = null, endTime = null;
        if (rangTime) {
          beginTime = rangTime.split(",")[0];
          beginTime = new Date(beginTime);
          endTime = rangTime.split(",")[1];
          endTime = new Date(endTime);
        }
        this.formObj.examBeginTime = beginTime;
        this.formObj.examEndTime = endTime;
        // console.log(this.formObj);
        if (this.formObj.proId == null) {
          this.$message({
            message: "请选择项目",
            type: 'error'
          });
        } else if (this.formObj.time == null) {
          this.$message({
            message: "请选择考试时间",
            type: 'error'
          });
        } else if (this.formObj.examName==null) {
          this.$message({
            message: "请输入考试名称",
            type: 'error'
          });
        }
          else {
          this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
            if (option == 0) {
                if(this.dataList == null || this.dataList.length == 0){
                  this.$message({
                    message: "试题加载失败，请检查数据",
                    type: 'error'
                  });
                  return ;
                }
              examCreate(this.formObj, this.GLOBAL.header).then(result => {
                if (result.success) {
                  this.$message({
                    message: "添加成功",
                    type: 'success'
                  });
                  this.$emit('doSubmit');
                } else {
                  this.$message({
                    message: "添加失败",
                    type: 'error'
                  });
                  this.$emit('doSubmit');
                }
              });
            } else if (option == 1) {
              examUpdate(this.formObj, this.GLOBAL.header).then(result => {
                if (result.success) {
                  this.$message({
                    message: "修改成功",
                    type: 'success'
                  });
                  this.$emit('doSubmit');
                }else {
                  this.$message({
                    message: "修改失败",
                    type: 'error'
                  });
                  this.$emit('doSubmit');
                }
              });
            }
          }).catch(() => {
          });
        }
      },
      doCancel: function () {
        this.$emit('doCancel');
      },
      successConUpload: function (response) {
        this.dataList = response.data;
        if (this.dataList != null) {

          let allFen = 0;
          for (let i = 0; i < this.dataList.length; i++) {
            try {
              this.dataNo[i] = parseInt(this.dataList[i].cell0) + parseInt(this.no);
              let n = parseInt(this.dataList[i].cell0) + parseInt(this.no);
              let o = {
                cell0: n,
                cell1: this.dataList[i].cell1,
                cell2: this.dataList[i].cell2,
                cell3: this.dataList[i].cell3,
                cell4: this.dataList[i].cell4,
                cell5: this.dataList[i].cell5
              }
              this.tempList[i] = o;
              allFen = allFen + parseFloat(this.dataList[i].cell5);
            } catch (e) {
              this.dataList = null;
              this.fileList = [];
              this.dataNo = [];
              allFen = 0;
              this.formObj.examAllFen = null;
              this.$message({
                message: "试题上传失败，请检查数据",
                type: 'error'
              });
            }
          }

          this.formObj.questionList = this.tempList;
          this.formObj.examAllFen = allFen;//计算总分
          this.formObj.examQuestion = this.dataNo.join(',');
        } else {
          this.fileList = [];
          this.$message({
            message: "试题上传失败，请检查数据",
            type: 'error'
          });
        }
      },
      removeConUpload: function () {
        this.dataList = [];
      },
      //上传限制
      handleExceed: function (files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      openRandomView: function (val) {
        if(val=='点击->随机生成试卷'){
          this.$refs.formObj.validate((valid) => {
            if (valid) {
              this.rForm={singleSelected:1,doubleSelected:1,checkSelected:1,allSelected:null};
              this.randomVisible = true;
              this.method='点击->随机生成试卷';
            }
            else {
              this.method='自定义';
            }
          });
        }
      },
      rCancel: function () {
        this.randomVisible = false;
        this.method = '自定义';
      },
      handleChange: function () {

      }
    },
    mounted() {
      //初始化数据
      //初始化表单数据
      if (this.option == 1) {
        this.formObj = this.formData;
        this.formObj.time = [this.formObj.examBeginTime, this.formObj.examEndTime];
      }
      examNO({}, this.GLOBAL.header).then(result => {
        if (result.success) {
          this.no = result.data;
        }
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/exam/ExamForm.vue